import React from "react";

import "./century_cup.scss";
import { observer } from "mobx-react-lite";

import century_cup_cover from "../../../assets/images/century_cup.png";
import cupStore from "../../../stores/cup_store/cup_store";

function CenturyCup() {
	return (
		<div className="century_cup">
			<div className="cover_wrapper">
				<img src={cupStore.cupInfo?.pic} alt=""></img>
			</div>
			<div className="description_wrapper">
				<div className="title">{cupStore.cupInfo?.title}</div>
				{cupStore.cupInfo && (
					<div
						className="description"
						dangerouslySetInnerHTML={{
							__html: cupStore.cupInfo.detail_text.replaceAll(
								"<br>",
								"<br><br>"
							),
						}}
					></div>
				)}
			</div>
		</div>
	);
}

export default observer(CenturyCup);
